import { useEffect, useState } from 'react'
import { getAppVersion } from '~/utils/common'

export const APP_VERSION_PLACEHOLDER = '?.?.?'

export const useAppVersion = () => {
  const [appVersion, setAppVersion] = useState<string>(APP_VERSION_PLACEHOLDER)

  const doGetAppVersion = async () => {
    const version = await getAppVersion()
    setAppVersion(version)
  }

  useEffect(() => {
    void doGetAppVersion()
  }, [])

  return appVersion
}
